import {
    FETCH_VEHICLES,
    FETCH_VEHICLES_SUCCESS,

    FETCH_VEHICLE_DETAILS,
    FETCH_VEHICLE_DETAILS_SUCCESS,

    ADD_NEW_VEHILCE,
    ADD_NEW_VEHILCE_SUCCESS,

    ADD_NEW_VEHILCE_SERVICE,
    ADD_NEW_VEHILCE_SERVICE_SUCCESS
} from "../actions/types";

import { showModal } from './'
export const fetchVehilcles = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_VEHICLES })
        setTimeout(() => {
            dispatch({ type: FETCH_VEHICLES_SUCCESS })
        }, 2000)
    }
}

export const addNewVehicle = (vehicle = {}, callBackAction = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: ADD_NEW_VEHILCE })
        setTimeout(() => {
            dispatch({ type: ADD_NEW_VEHILCE_SUCCESS, payload: { vehicle } })
            callBackAction()
            dispatch(showModal({ title: 'Success', body: `Your ${"assetNumber" in vehicle ? 'item' : 'vehicle'} was successfully added`, isSuccess: true }))
        }, 2000)
    }
}

export const fetchVehicleDetails = (vehicleNumber) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_VEHICLE_DETAILS })
        setTimeout(() => {
            dispatch({ type: FETCH_VEHICLE_DETAILS_SUCCESS, payload: { "vehicleNumber": vehicleNumber } })
        }, 300)
    }
}

export const addVehicleService = (service = {}, callBackAction = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: ADD_NEW_VEHILCE_SERVICE_SUCCESS, payload: { "service": service } })
        callBackAction()
        dispatch(showModal({ title: 'Success', body: `Your ${"mileage" in service ? 'vehicle' : 'item'}'s service was successfully added`, isSuccess: true }))
    }
}